import { render } from "./ProductsBasket.vue?vue&type=template&id=7604ea12&scoped=true&ts=true"
import script from "./ProductsBasket.vue?vue&type=script&lang=ts"
export * from "./ProductsBasket.vue?vue&type=script&lang=ts"

import "./ProductsBasket.vue?vue&type=style&index=0&id=7604ea12&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7604ea12"]])

export default __exports__